import React from 'react';
import { useCareTypeStepProvider } from '@/applications/application-provider';
import { ArrowRightOutlined } from '@ant-design/icons';
import { CareTypeReference } from '@/client/models';
import { InfoCard } from '@/components/info-card';
import { useTranslate } from '@/language-provider';
import { CareTypeStepProvider } from '@/applications/care-type-step-provider';

const CareTypeComponent: React.FC<{ careType: CareTypeReference; provider: CareTypeStepProvider }> = ({ careType, provider }) => {
    const { translate } = useTranslate();

    provider.setCareType(undefined);

    function ageLine(careType: CareTypeReference): string {
        if (careType.toAge != null) {
            return translate('applications.steps.careType.fromToAge', { from: careType.fromAge, to: careType.toAge }).toString();
        }
        return translate('applications.steps.careType.fromAge', { from: careType.fromAge }).toString();
    }

    return (
        <InfoCard
            icon={<ArrowRightOutlined />}
            title={careType.name}
            lines={[ageLine(careType)]}
            onClick={() => provider.toggleCareType(careType)}
             />
    );
};

export const CareTypeStep: React.FC = () => {
    const provider = useCareTypeStepProvider();
    const careTypes = provider.getCareTypes();

    return (<>{careTypes.map(x => <CareTypeComponent key={x.name} careType={x} provider={provider} />)}</>);
};